import { AlertTriangle, AlertCircle, Info, ChevronRight } from "lucide-react";
import { cn } from "../../lib/utils";
import { Button } from "../ui/button";
import { useNavigate } from "react-router-dom";
export function AlertCard({ type, title, description, action, actionUrl }) {
  const navigate = useNavigate();
  const typeStyles = {
    critical: {
      bg: "bg-destructive/10 border-destructive/30",
      icon: AlertTriangle,
      iconColor: "text-destructive",
    },
    warning: {
      bg: "bg-warning/10 border-warning/30",
      icon: AlertCircle,
      iconColor: "text-warning",
    },
    info: {
      bg: "bg-primary/10 border-primary/30",
      icon: Info,
      iconColor: "text-primary",
    },
  };

  const styles = typeStyles[type];
  const Icon = styles.icon;

  return (
    <div
      className={cn("rounded-xl border p-4 flex items-start gap-4", styles.bg)}
    >
      <div
        className={cn(
          "w-10 h-10 rounded-lg flex items-center justify-center flex-shrink-0",
          styles.bg,
        )}
      >
        <Icon className={cn("w-5 h-5", styles.iconColor)} />
      </div>
      <div className="flex-1 min-w-0">
        <h4 className="font-semibold text-foreground text-sm">{title}</h4>
        <p className="text-sm text-muted-foreground mt-1">{description}</p>
      </div>
      {action && actionUrl && (
        <Button
          variant="ghost"
          size="sm"
          onClick={() => navigate(actionUrl)}
          className="flex-shrink-0"
        >
          {action}
          <ChevronRight className="w-4 h-4 ml-1" />
        </Button>
      )}
    </div>
  );
}
